
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';
import TagCard from '~/components/banner-block/TagCard.vue';

export default BaseCmsBlock.extend({
    name: 'BannerBlock',

    data() {
        return {
            swiperOptions: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
                // loop: true,
                effect: 'fade',
                // autoplay: {
                //   delay: 3000,
                //   disableOnInteraction: false,
                //   pauseOnMouseEnter: false
                // },

                navigation: {
                    prevEl: '.banner-block__button-navition--prev',
                    nextEl: '.banner-block__button-navition--next',
                },
            },
            windowWidth: null,
        };
    },

    components: {
        Swiper,
        SwiperSlide,
        TagCard
    },

    methods: {
        scrollToDown() {
            const headerHeight = document.getElementsByClassName('header')?.[0].getBoundingClientRect().height;
            const bannerHeight = this.$refs.refBannerBlock.getBoundingClientRect()?.height;
            window.scrollTo({
                top: bannerHeight,
                behavior: 'smooth',
            });
        },

        openFormPopUp() {
            this.$store.commit('back-call/setOpen', {
                open: true,
                settings: {
                    title: 'Заказать консультацию',
                    reachGoal: 'ostavil_zayavky_v_shapke',
                },
            });
        },
        handleWindowSize() {
          this.windowWidth = window.innerWidth;
        },
    },
    computed: {
      isMobile() {
        return this.windowWidth < 640;
      }
    },

    mounted: function() {
      this.handleWindowSize();
      window.addEventListener('resize', this.handleWindowSize, true);
    },
    unmounted: function () {
      window.removeEventListener('resize', this.handleWindowSize);
    },
});
